import { render, staticRenderFns } from "./AddSetting.vue?vue&type=template&id=41d7e457&scoped=true"
import script from "./AddSetting.vue?vue&type=script&lang=js"
export * from "./AddSetting.vue?vue&type=script&lang=js"
import style0 from "./AddSetting.vue?vue&type=style&index=0&id=41d7e457&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7e457",
  null
  
)

export default component.exports